export const GROUP_TYPES = [
	{ label: 'Admin', value: 'a' },
	{ label: 'Regional Contact', value: 'rc' },
	{ label: 'Studio Department', value: 'sd' },
	{ label: 'Vendor', value: 'v' }
];

const DNG_CATEGORIES = {
	dialogue: 'Dialogue',
	narration: 'Narration',
	graphics: 'Graphics'
};

const DNG_LEVELS = ['OV', 'Dedicated', 'Subtitled'];

export const DNG_OPTIONS = Object.entries(DNG_CATEGORIES).flatMap(([category, label]) => {
	return DNG_LEVELS.map((level) => ({
		value: `${category}_${level}`,
		label: `${label} ${level}`
	}));
});

export const LOCALIZATION_TYPES = [
	{
		label: 'OV',
		value: 'ov'
	},
	{
		label: 'Dedicated / Localized',
		value: 'dedicated'
	},
	{
		label: 'Subtitled',
		value: 'subtitled'
	}
];

export const LANGUAGE_FONT_FACES = [
	{ label: 'Angsana New', value: 'Angsana New' },
	{ label: 'Arial', value: 'Arial' },
	{ label: 'Arial Unicode MS', value: 'Arial Unicode MS' },
	{ label: 'SimHei', value: 'SimHei' },
	{ label: 'Narkisim', value: 'Narkisim' },
	{ label: 'NanumGothic', value: 'NanumGothic' },
	{ label: 'SFProAR', value: 'SFProAR' },
	{ label: 'SFProDisplay-Light', value: 'SFProDisplay-Light' },
	{ label: 'SFProJPDisplay', value: 'SFProJPDisplay' },
	{ label: 'SFProKRDisplay', value: 'SFProKRDisplay' },
	{ label: 'SFProSCDisplay', value: 'SFProSCDisplay' },
	{ label: 'SFProTCDisplay', value: 'SFProTCDisplay' },
	{ label: 'SFProTHDisplay', value: 'SFProTHDisplay' }
];

export const LANGUAGE_FONT_WEIGHT = [
	{ label: 'Regular', value: 400 },
	{ label: 'Bold', value: 700 }
];

export const PERMISSION_ACTION_LABELS = {
	'social': 'Social Publish',
	'autosub': 'Automated Subtitles',
	'autosubs': 'Automated Subtitles',
	'voting': 'Voting',
	'download': 'Download',
	'notes': 'Add/Edit Notes',
	'requests': 'Place Orders',
	'previews': 'Previews',
	'sharing': 'Unrestricted Sharing',
	'ingest': 'Ingest Assets',
	'modifySubs': 'Modify Subtitles',
	'adminWorkRequests': 'Admin Work Requests',
	'manageWorkRequests': 'Manage Work Requests',
	'projectAdminView': 'View Projects & Assets',
	'projectAdminUpdate': 'Update Projects & Assets',
	'projectAdminEmbargos': 'Manage Embargoes',
	'workRequestReport': 'Reports: Work Requests',
	'groupSpendingReport': 'Reports: Group Spending Summary',
	'exceptionReport': 'Reports: Group Exceptions',
	'downloadReport': 'Reports: Downloads',
	'feedbackReport': 'Reports: Feedback',
	'shareReport': 'Reports: Shares',
	'encodeReport': 'Reports: Encodes',
	'privateAccess': 'Blanket Access to Private Assets'
};
